import { Header } from "./shared/Header";
import CoffeMenu from "./pages/CoffeMenu";
/* import { Footer } from "./shared/Footer"; */
import MyContext from "./context/MyContext";
import "./App.css";
import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, } from "react-router-dom"
import SearchList from "./pages/SearchList";
// Define the data structure for Coffee items
interface DataFilter {
  id: number;
  name: string;
  category: string[];
  kind: {
    type: string;
    description: string;
    img: string;
  }[];
  price: string;
}

function App() {
  const [state, setState] = useState(false);
  const [Refrch, setRefrch] = useState(false);
  const [Coffee, setCoffee] = useState<any>(JSON.parse(localStorage.getItem("DataCoffee") || "[]"));
  const [DataWithFilter, setDataWithFilter] = useState<DataFilter[]>([]);
  const [DataByCategory, setDataByCategory] = useState<string[]>(["الكل"]);

  useEffect(() => {
    setCoffee(JSON.parse(localStorage.getItem("DataCoffee") || "[]"))
  }, [Refrch])
  return (
    <>

      <Router>
        <MyContext.Provider value={{ state, setState, Coffee, setCoffee, Refrch, setRefrch }}>

          <Routes>
            <Route path="*" element={
              <>
                <Header />
                <CoffeMenu DataByCategory={DataByCategory} setDataByCategory={setDataByCategory} DataWithFilter={DataWithFilter} setDataWithFilter={setDataWithFilter} />
              </>} />
            <Route path="Search" element={<SearchList />} />
          </Routes>
          {/* <Footer  /> for menue price v2 */}
        </MyContext.Provider>

      </Router>
    </>

  );
}

export default App;
